import blankAction from '../assets/images/bbBlankAction.png'
import getCombatantSlots from './getCombatantSlots'
import getRoundOccupiedSlotEntries from './getRoundOccupiedSlotEntries'

export default async function getCombatantPreviousRoundActionImage(
  combatant,
  round,
  extraActionSlot = null,
) {
  console.log('------------------------------------------------')
  console.log('IN getCombatantPreviousRoundActionImage = ', {
    name: combatant?.name,
    slug: combatant?.slug,
    round,
  })

  if (!combatant?.slug || !Number.isFinite(round) || round <= 1) {
    console.log('getCombatantPreviousRoundActionImage early return due to invalid combatant/round')
    return ''
  }

  const slots = await getCombatantSlots(combatant.slug)
  const previousRound = round - 1
  const blockedExtraSlot = Number(extraActionSlot)
  const hasBlockedExtraSlot = Number.isFinite(blockedExtraSlot) && blockedExtraSlot > 0
  const previousRoundEntries = getRoundOccupiedSlotEntries(slots, previousRound, {
    blockedSlot: hasBlockedExtraSlot ? blockedExtraSlot : null,
  })
  const previousRoundAction = previousRoundEntries[0]

  console.log('getCombatantPreviousRoundActionImage action summary = ', {
    name: combatant?.name,
    previousRound,
    blockedExtraSlot: hasBlockedExtraSlot ? blockedExtraSlot : null,
    actionCount: Array.isArray(slots?.actions) ? slots.actions.length : 0,
    markerCount: Array.isArray(slots?.markers) ? slots.markers.length : 0,
    previousRoundActionCount: previousRoundEntries.length,
    selectedAction: previousRoundAction
      ? {
          action_name: previousRoundAction.name,
          number: previousRoundAction.number,
          action_image: previousRoundAction.image,
          kind: previousRoundAction.kind,
        }
      : null,
    fallbackImage: previousRoundAction?.image || blankAction,
  })

  return previousRoundAction?.image || blankAction
}
